// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { MetricHandler } from "./handler.js";
